// URL search params for the Offers page (EPD-12459, EPD-12460). Keeping the
// tab, view and open brand in the URL is what lets Back from an offer's
// dashboard return to the same page (EPD-12461). Group by isn't in the URL:
// every visit starts on Brand (EPD-12586).

import type { CreatorAffiliateOffer } from "@/lib/queries/promo-codes";
import type { OfferTab } from "./tabs";

/** Defaults (Active, Grid) are left out of the URL. */
export interface OffersSearch {
  tab?: Exclude<OfferTab, "active">;
  view?: "list";
  /** A brand's offers within the current tab. */
  brand?: string;
  /** The old Group by param; always cleared. */
  groupBy?: undefined;
}

/**
 * Every key is set, even to undefined: the router layers this over the raw URL
 * params, so a key left out would let a stale value through.
 */
export function parseOffersSearch(raw: Record<string, unknown>): OffersSearch {
  return {
    tab:
      raw.tab === "expired" || raw.tab === "deactivated" ? raw.tab : undefined,
    view: raw.view === "list" ? "list" : undefined,
    brand:
      typeof raw.brand === "string" && raw.brand.length > 0
        ? raw.brand
        : undefined,
    groupBy: undefined,
  };
}

export interface OfferBrand {
  clientId: string;
  clientName: string;
}

/**
 * The brand whose offers are open, when that brand has offers in the current
 * tab. Otherwise the list shows.
 */
export function openOfferBrand(
  tabOffers: readonly CreatorAffiliateOffer[],
  search: OffersSearch,
): OfferBrand | null {
  if (!search.brand) return null;
  const offer = tabOffers.find((o) => o.clientId === search.brand);
  return offer
    ? { clientId: offer.clientId, clientName: offer.clientName }
    : null;
}
